import Points from './Points'

export * from './types'

export default Points
